;(function($){



var customJS = function() {
	console.log('CPB is here');

}

//   script for build-a-belt cpb product page tabs 
  var cpbTabs = function() {
      $('.swiper-wrapper-custom-product').each(function(){
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
          $($(this).attr('href')).hide();
        });
        $(this).find('a').click(function(e){
          active.removeClass('active');
          content.hide();
          active = $(this);
          content = $($(this).attr('href'));
          active.addClass('active');
          content.show();
          return false;
          
          
      return false;
          
        });
      });
    };

/** 
* Function wait CPB DOM elements to show up.
* Work in modern browsers.
* And execute callback.
*/
var cpbLoaded = function() {
  if (jQuery('.cpb-panel-wrapper').length > 0) {

  	console.log('CPB is loaded');

  	customJS();
    cpbTabs();
  } else {
  window.requestAnimationFrame(cpbLoaded);
  } 
};

cpbLoaded(); 


})(jQuery);